export const ID = '@report'

export default {
  ID: ID,
  LIST_PROPERTY_REPORTS: `${ID}/LIST_PROPERTY_REPORTS`,
  GET_DIMENSION_ITEMS: `${ID}/GET_DIMENSION_ITEMS`,
  GET_STAFFS_ROLES_NAMES: `${ID}/GET_STAFFS_ROLES_NAMES`,
}
